import { render, staticRenderFns } from "./LibraryView.vue?vue&type=template&id=bfe27986&scoped=true"
import script from "./LibraryView.vue?vue&type=script&lang=js"
export * from "./LibraryView.vue?vue&type=script&lang=js"
import style0 from "./LibraryView.vue?vue&type=style&index=0&id=bfe27986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe27986",
  null
  
)

export default component.exports